import type { AdminHostPoolWithType } from "@/admin/host_pools/hostPoolsQuery.ts";
import { defaultVmsMutation } from "@/admin/host_pools/hostPoolsQuery.ts";
import { WModal, WModalContent } from "@/components/modal/WModal.tsx";
import { useStandardMutation } from "@/modules/api/useStandardMutation.ts";
import type { ReactNode } from "react";

export function ToggleDefaultDesignatedModal({ button, item }: { button: ReactNode; item: AdminHostPoolWithType }) {
    const updateMutation = useStandardMutation(defaultVmsMutation);

    async function onToggle() {
        await updateMutation.mutateAsync({
            location: item.location,
            uuid: item.uuid,
        });
    }

    return (
        <WModal button={button}>
            <WModalContent title="Set Default Pool" label="Set Default" modalAction={async () => await onToggle()}>
                <p>
                    This pool will be the default if user does not specifically choose another pool when creating a
                    Virtual Machine.
                </p>
            </WModalContent>
        </WModal>
    );
}
